module.exports = __webpack_public_path__ + "img/object.44efb3aa.png";